export default "__VITE_ASSET__CuOu7zD7__"